/**
 * PlatformMonitoringDashboard Component Styles
 * Carbon Design System compliant styles with WCAG 2.5.5 touch target compliance
 */
/* KPI Metric Tiles - Carbon Tile with proper elevation and consistent sizing */
.metricTile {
  padding: var(--cds-spacing-05);
  text-align: center;
  min-height: 160px; /* Consistent height for all metric tiles */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* Carbon Tile elevation - matches cds--tile behavior */
  background-color: var(--cds-layer-01);
  /* Ensure responsive behavior on mobile */
}
@media (max-width: 671px) {
  .metricTile {
    min-height: 140px; /* Slightly smaller on mobile to prevent overflow */
    padding: var(--cds-spacing-04);
  }
}

.metricIcon {
  margin-bottom: var(--cds-spacing-03);
  color: var(--cds-icon-primary);
  /* Ensure icon is properly sized */
  flex-shrink: 0;
}

.metricValue {
  color: var(--cds-text-primary);
  margin: var(--cds-spacing-02) 0;
  word-break: break-word; /* Prevent overflow on long numbers */
}

.metricLabel {
  color: var(--cds-text-secondary);
  margin-top: var(--cds-spacing-02);
}

.alertContainer {
  margin-bottom: var(--cds-spacing-05);
}

.statusIndicator {
  display: flex;
  align-items: center;
  gap: var(--cds-spacing-02);
}

.monitoringGrid {
  gap: var(--cds-spacing-05);
}

/* Dashboard Container - Mobile responsive with no horizontal scroll */
.dashboardContainer {
  padding: var(--cds-spacing-06);
  max-width: 100%;
  overflow-x: hidden; /* Prevent horizontal scroll */
  /* Mobile responsive padding */
}
@media (max-width: 671px) {
  .dashboardContainer {
    padding: var(--cds-spacing-04);
  }
}

/* Dashboard Header - Responsive flex layout */
.dashboardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--cds-spacing-06);
  gap: var(--cds-spacing-05);
  /* Stack on mobile */
}
@media (max-width: 671px) {
  .dashboardHeader {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--cds-spacing-04);
  }
}

/* Dashboard Controls - Responsive button group */
.dashboardControls {
  display: flex;
  gap: var(--cds-spacing-03);
  /* Stack on mobile */
}
@media (max-width: 671px) {
  .dashboardControls {
    flex-direction: column;
    width: 100%;
    /* Make select and button full width on mobile */
  }
  .dashboardControls > * {
    width: 100%;
  }
}

/* Tab Navigation - Responsive tabs */
.tabNavigation {
  border-bottom: 1px solid var(--cds-border-subtle);
  margin-bottom: var(--cds-spacing-06);
  overflow-x: auto; /* Allow horizontal scroll for tabs if needed on small screens */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.tabButtons {
  display: flex;
  gap: var(--cds-spacing-03);
  min-width: min-content; /* Prevent wrapping */
  /* On mobile, ensure buttons don't shrink too much */
}
@media (max-width: 671px) {
  .tabButtons {
    gap: var(--cds-spacing-02);
  }
}

.dashboardContent {
  padding: var(--cds-spacing-05);
  /* Reduce padding on mobile */
}
@media (max-width: 671px) {
  .dashboardContent {
    padding: var(--cds-spacing-03);
  }
}

.performanceChart {
  height: 300px;
  background-color: var(--cds-layer-01);
  border: 1px solid var(--cds-border-subtle);
  border-radius: var(--cds-border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: var(--cds-spacing-03);
}

.chartPlaceholder {
  color: var(--cds-text-helper);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */